import { connect, Dispatch } from 'react-redux'
import { RouteConfigComponentProps } from 'react-router-config'

import { IStatsData } from '../../../common/actions/common'
import {
  closeModal,
  initToggledPanels,
  openModal
} from '../../../common/actions/layout'
import { getUser } from '../../../common/actions/user/'
import { initClientUserSearchResultsViewType } from '../../../common/actions/user/preference'
import { Site } from '../../../common/constants/siteList'
import { IRootState } from '../../../common/reducers'
import { IPageSeoMeta } from '../../../typings/seoMetadata'

interface IOwnProps extends RouteConfigComponentProps<any> {
  location: any // TODO: REMOVE THIS WHEN LOCATION IS NOT ADDING QUERY
}

interface IStateProps {
  baseUrl: string
  currentSite: Site
  errorPage: any
  isModalOpen: boolean
  noIndex: boolean
  openModalData: any
  openModalType: any
  seoMeta: IPageSeoMeta
  stats: IStatsData | null
  canonicalPath: string
}

interface IDispatchProps {
  closeModal: () => any
  initUser: () => void
  openModal: (data: any) => any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { layout, common, searchPage, marketing } = state
  const {
    baseUrl,
    currentSite,
    errorPage,
    menuConfig,
    noIndex,
    seoMeta,
    stats,
    canonicalPath
  } = common
  const { isModalOpen, openModalType, openModalData } = layout
  const { banners } = marketing

  return {
    baseUrl,
    currentSite,
    errorPage,
    isModalOpen,
    noIndex,
    openModalData,
    openModalType,
    seoMeta,
    stats,
    canonicalPath
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IRootState>,
  ownProps: IOwnProps
): IDispatchProps => {
  return {
    closeModal: () => dispatch(closeModal()),
    initUser: () => {
      dispatch(initClientUserSearchResultsViewType(ownProps.location) as any)
      dispatch(getUser() as any)
      dispatch(initToggledPanels() as any)
    },
    openModal: (data: any) => dispatch(openModal(data))
  }
}

export type Props = IOwnProps & IDispatchProps & IStateProps

const createAppContainer = (component: React.ComponentType<Props>) => {
  return connect<IStateProps, IDispatchProps, IOwnProps, IRootState>(
    mapStateToProps,
    mapDispatchToProps
  )(component)
}

export default createAppContainer
